import { App, formatEuro, useCurrentApp, useIntl } from '@finn/ui-utils';

import { GenericVehicleDetails } from '../../core/types';

// quick toggle in case product want to exclude it from calculation
const SHOULD_CONSIDER_KM_PACKAGE = true;

export const useProductLabel = (
  vehicle: GenericVehicleDetails,
  partnerDiscount?: number
) => {
  const intl = useIntl();
  const isB2BApp = useCurrentApp() === App.B2B;

  if (!vehicle.availability) {
    return intl.formatMessage('plp.outOfStock');
  }

  if (!partnerDiscount) {
    let label = vehicle.product_label?.label;

    if (label?.toLowerCase().includes('juli10') && isB2BApp) {
      label = '10 % Rabatt';
    }

    return label;
  }

  // Calculate max partner discount savings label
  const longestTerm = Math.max(...vehicle.available_terms);
  const longestTermMonthlyPrice =
    vehicle.price.available_price_list[`b2c_${longestTerm}`];

  const highestMonthlyPrice =
    longestTermMonthlyPrice +
    (SHOULD_CONSIDER_KM_PACKAGE ? vehicle.price.extra_5000 : 0);

  const totalPrice = longestTermMonthlyPrice
    ? highestMonthlyPrice * longestTerm
    : 0;
  const totalDiscount = totalPrice * partnerDiscount;

  if (totalDiscount) {
    return intl.formatMessage('plp.saveUpto', {
      amount: formatEuro(totalDiscount, intl),
    });
  }

  return undefined;
};
